module.exports = __webpack_public_path__ + "05_mustache_silver.11893770.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/05_mustache_silver.png
// module id = OFeH
// module chunks = 0